<script>
export default {
    props: {
        value: [Number, String],
        min: {
            type: [Number, String],
            default: 1
        },
        max: [Number, String]
    },
    name: "length",
    data() {
        return {
            inputValue: this.value,
        };
    },
    computed: {

    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        value(value) {
            this.inputValue = value;
        },
    },
    methods: {
        less() { 
            let _value = this.inputValue;
            if (this.min && _value <= this.min) { 
                return;
            }
            this.$emit("input", --_value);
            this.inputValue = _value;
            this.$emit("change", _value);
        },
        add() {
            let _value = this.inputValue;
            if (this.max && _value >= this.max) { 
                return;
            }
            this.$emit("input", ++_value);
            this.inputValue = _value;
            this.$emit("change", _value);
        },
        blur(e) { 
            let _value;
            if (e.target.value == '') { 
                // 为空就取最小值或者1
                _value = this.min ? this.min : 1;
            } else {
                // 取整
                _value = parseInt(e.target.value);
                // 判断最大最小值
                if (this.min && _value < this.min) _value = this.min;
                if (this.max && _value > this.max) _value = this.max;
            }
            // 输出
            this.$emit("input", _value);
            this.inputValue = _value;
        },
    },
};
</script>

<template>
    <div class="length">
        <div class="btn_less" @click="less"></div>
        <input type="number" class="num" v-model="inputValue" @blur="blur"/>
        <div class="btn_add" @click="add"></div>
    </div>
</template>

<style scoped lang="scss">
.length{
    border: 1px solid #000;
    display: inline-flex;
    .btn_less,
    .btn_add{
        width: .4rem;
        height: .4rem;
        position: relative;
        cursor: pointer;
        @media only screen and (max-width: 750px) {
            width: .5rem;
            height: .5rem;
        }
        &::before,
        &::after{
            content: "";
            display: block;
            width: 30%;
            border-bottom: 1px solid #000;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &::after{
            transform: translate(-50%, -50%) rotate(90deg);
        }
    }
    .btn_less{
        &::after{
            display: none;
        }
    }
    .num{
        appearance: none;
        width: .7rem;
        height: .4rem;
        font-size: .25rem;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
        text-align: center;
        @media only screen and (max-width: 750px) {
            width: .9rem;
            height: .5rem;
            font-size: .28rem;
        }
    }
}
</style>